module.exports = __webpack_public_path__ + "media/סל.92189a97.mp3";